export const sidebarData = [
  { path: "/", icon: "home", optionName: "Home" },
  { path: "/explore", icon: "explore", optionName: "Explore" },
  { path: "/playlists", icon: "video_library", optionName: "Playlists" },
  {
    path: "/watch-later",
    icon: "watch_later",
    optionName: "Watch later",
  },
  {
    path: "/liked-videos",
    icon: "thumb_up",
    optionName: " Liked videos",
  },
  { path: "/history", icon: "history", optionName: "History" },
];
